import { render } from "./DynamicChartCirc.vue?vue&type=template&id=22f6dd24&ts=true"
import script from "./DynamicChartCirc.vue?vue&type=script&lang=ts"
export * from "./DynamicChartCirc.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"shared/src/entidades/builder/form/infrastructure/controls/editorTemplates/prime/DynamicChartCirc.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "22f6dd24"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('22f6dd24', __exports__)) {
    api.reload('22f6dd24', __exports__)
  }
  
  module.hot.accept("./DynamicChartCirc.vue?vue&type=template&id=22f6dd24&ts=true", () => {
    api.rerender('22f6dd24', render)
  })

}


export default __exports__